var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00208 2.04249C4.00208 2.84213 3.39322 3.48927 2.44106 3.48927C1.52599 3.48927 0.917129 2.84213 0.935972 2.04249C0.917129 1.20398 1.52598 0.575684 2.4593 0.575684C3.3932 0.575684 3.98383 1.20398 4.00208 2.04249ZM1.01252 13.9465V4.63221H3.90727V13.9459L1.01252 13.9465Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22803 7.60453C6.22803 6.44275 6.18975 5.45231 6.15147 4.63323H8.66583L8.79949 5.90926H8.85662C9.2376 5.31865 10.1898 4.4242 11.7325 4.4242C13.6369 4.4242 15.0654 5.68137 15.0654 8.42302V13.9475H12.1706V8.78575C12.1706 7.5851 11.752 6.76661 10.7044 6.76661C9.90417 6.76661 9.42839 7.31894 9.23819 7.85184C9.16164 8.04263 9.12396 8.30878 9.12396 8.57612V13.9475H6.2292V7.60453H6.22803Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.60f18f97136120328eac2e282fbf2b5a.svg";
export { ForwardRef as ReactComponent };